import { Injectable } from "@angular/core";
import { WizardFlowContext } from "../../../wizard-flow-context.model";
import { GenericStepFactory } from "./generic-step.factory";
import { NextStepDeciderFactory } from "./next-step-decider.factory";
import { ICreateStep } from "./step-factory.interface";
import { OwnRentStep } from "../../own-rent-step-model";
import { OwnRentStepConfig } from "../own-rent-step-config.model";

@Injectable()
export class OwnRentStepFactory extends GenericStepFactory<OwnRentStep> implements ICreateStep {

  constructor(nextStepDeciderFactory: NextStepDeciderFactory) {
    super(nextStepDeciderFactory, OwnRentStep);
  }

  create(config: OwnRentStepConfig, wizardFlowContext: WizardFlowContext): OwnRentStep {
    return super.create(config, wizardFlowContext);
  }

  configure(step: OwnRentStep, config: OwnRentStepConfig): void {
    super.configure(step, config);
  }
}
